var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-second"},_vm._l((_vm.router),function(nav){return _c('router-link',{key:nav.name,staticClass:"nav-second-item",attrs:{"tag":"div","to":nav.path,"exact-active-class":"nav-second-item_ac"}},[_c('img',{attrs:{"src":_vm.getImage(nav),"alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }